"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortEvents = sortEvents;
const run_toposort_1 = require("../utils/run-toposort");
const trace_deps_1 = require("../utils/trace-deps");
const termPropertiesRelatedToValue = [
    "value",
    "hasValue",
    "isValid",
    "isComplete",
];
function sortEvents(events, eventSetReference, expressionReference, isReadyEvent = false) {
    const edges = [];
    const unusedEvents = new Set(events);
    const addEdge = (from, to) => {
        // Avoid a circular dependency of depending on itself
        if (!from || from === to) {
            return;
        }
        unusedEvents.delete(from);
        unusedEvents.delete(to);
        edges.push([from, to]);
    };
    // Trace dependencies to a term value
    for (const eventSet of events) {
        for (const dep of eventSet.dependencies) {
            if (dep.property === "count") {
                for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(expressionReference.iterables[dep.iterableName]?.count?.dependencies, expressionReference)) {
                    addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                }
                continue;
            }
            if (dep.property === "label") {
                for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(getTermExpRef(expressionReference, dep)?.label?.dependencies, expressionReference)) {
                    addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                }
                continue;
            }
            if (dep.property === "isRelevant" ||
                dep.property === "isRequired" ||
                dep.property === "isComplete") {
                for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(getTermExpRef(expressionReference, dep)?.relevant?.dependencies, expressionReference)) {
                    addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                }
                if (dep.property === "isRequired" || dep.property === "isComplete") {
                    for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(getTermExpRef(expressionReference, dep)?.required?.dependencies, expressionReference)) {
                        addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                    }
                }
            }
            if (dep.property === "isReadonly") {
                for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(getTermExpRef(expressionReference, dep)?.readonly?.dependencies, expressionReference)) {
                    addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                }
                continue;
            }
            if ((dep.type === "term" || dep.type === "iterable-term") &&
                (termPropertiesRelatedToValue.includes(dep.property) ||
                    (dep.property === "ready" && isReadyEvent))) {
                addEdge(getTermEventSetRef(eventSetReference, dep), eventSet);
                for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(getTermExpRef(expressionReference, dep)?.calculate?.dependencies, expressionReference)) {
                    addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                }
                if (dep.property === "isValid" || dep.property === "isComplete") {
                    for (const refLocation of (0, trace_deps_1.traceDepsToTerms)(getTermExpRef(expressionReference, dep)?.validation?.dependencies, expressionReference)) {
                        addEdge(getTermEventSetRef(eventSetReference, refLocation), eventSet);
                    }
                }
            }
        }
    }
    // array combining unusedEvents and sorted events by dependency
    return Array.from(unusedEvents).concat((0, run_toposort_1.runToposort)(edges));
}
function getTermExpRef(reference, node) {
    if (node.type === "iterable-term") {
        return reference.iterables[node.iterableName]?.terms[node.termName];
    }
    return reference.terms[node.termName];
}
function getTermEventSetRef(reference, node) {
    if (node.type === "iterable-term") {
        return reference.iterables[node.iterableName]?.[node.termName];
    }
    return reference.terms[node.termName];
}
//# sourceMappingURL=sort-events.js.map